import uniq from 'lodash-es/uniq';
import {
    BlogsPopularFeedFetchFailureAction,
    BlogsPopularFeedFetchRequestAction,
    BlogsPopularFeedFetchSuccessAction,
    BLOGS_POPULAR_FEED_FETCH_FAILURE,
    BLOGS_POPULAR_FEED_FETCH_REQUEST,
    BLOGS_POPULAR_FEED_FETCH_SUCCESS,
} from 'mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeed.actions';
import {
    CommentsFetchFailureAction,
    CommentsFetchRequestAction,
    CommentsFetchSuccessAction,
    COMMENTS_FETCH_FAILURE,
    COMMENTS_FETCH_REQUEST,
    COMMENTS_FETCH_SUCCESS,
} from 'mk2/apps/blogs/containers/Comments/Comments.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface BlogsPopularFeedPageState {
    feedItemIds: number[];
    hasMore: boolean;
    errorMessage: string;
    loadingState: LoadingState;
}

export const initialBlogsPopularFeedPageState: BlogsPopularFeedPageState = {
    feedItemIds: [],
    hasMore: false,
    errorMessage: null,
    loadingState: LoadingState.INIT,
};

type BlogsPopularFeedPageReducerAction =
    BlogsPopularFeedFetchRequestAction
    | BlogsPopularFeedFetchSuccessAction
    | BlogsPopularFeedFetchFailureAction;

const blogsPopularFeedPageReducer: Reducer<BlogsPopularFeedPageState> = (state = initialBlogsPopularFeedPageState, action: BlogsPopularFeedPageReducerAction) => {
    switch (action.type) {
        case BLOGS_POPULAR_FEED_FETCH_REQUEST:
        case BLOGS_POPULAR_FEED_FETCH_FAILURE:
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });

        case BLOGS_POPULAR_FEED_FETCH_SUCCESS:
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
                hasMore: action.hasMore,
                feedItemIds: uniq([ ...state.feedItemIds, ...action.response.result.feedItems ]),
            });

        default:
            return state;
    }
};

interface BlogsPopularFeedByQueryState {
    // Blog's friend feed - api actually not support search by query, but wee keep this structure, see below, to be
    // aligned with other blog/group feed pages
    [query: string]: BlogsPopularFeedPageState;
}

export const queryKey = (query): string => `feedItems:${query || ''}`;

const searchKey = (action) => queryKey(action.query);

export interface BlogsPopularFeedState {
    commentsLoadingState: LoadingState;
    errorMessage: string;
    searches: BlogsPopularFeedByQueryState;
}

export const initialBlogsPopularFeedState: BlogsPopularFeedState = {
    commentsLoadingState: LoadingState.INIT,
    errorMessage: null,
    searches: {},
};

type BlogsPopularFeedReducerAction =
    CommentsFetchRequestAction
    | CommentsFetchSuccessAction
    | CommentsFetchFailureAction
    | BlogsPopularFeedFetchRequestAction
    | BlogsPopularFeedFetchSuccessAction
    | BlogsPopularFeedFetchFailureAction;

const blogsPopularFeedReducer: Reducer<BlogsPopularFeedState> = (state = initialBlogsPopularFeedState, action: BlogsPopularFeedReducerAction) => {
    switch (action.type) {
        case COMMENTS_FETCH_REQUEST:
        case COMMENTS_FETCH_SUCCESS:
        case COMMENTS_FETCH_FAILURE:
            return tupdate(state, {
                commentsLoadingState: loadingState(undefined, action),
            });

        case BLOGS_POPULAR_FEED_FETCH_REQUEST:
        case BLOGS_POPULAR_FEED_FETCH_FAILURE:
            return tupdate(state, {
                searches: tupdate(state.searches, {
                    [searchKey(action)]: blogsPopularFeedPageReducer(state.searches[searchKey(action)], action),
                }),
            });

        case BLOGS_POPULAR_FEED_FETCH_SUCCESS:
            return tupdate(state, {
                searches: tupdate(state.searches, {
                    [searchKey(action)]: blogsPopularFeedPageReducer(state.searches[searchKey(action)], action),
                }),
            });

        default:
            return state;
    }
};

export default blogsPopularFeedReducer;
